exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".material-icons.action-icon[data-v-2e9ae2c0]{font-size:18px;margin:.25rem;color:#eee;transition:color .5s ease,opacity .5s ease .25s}.material-icons.action-icon[data-v-2e9ae2c0]:hover{color:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2e9ae2c0&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/EditCategoryTrigger.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-2e9ae2c0&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/EditCategoryTrigger.vue
// module chunks = 0